import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body { 
    margin: 0;
    font-family: 'DM Sans', sans-serif;
  }
` 

export default GlobalStyle